var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContinuous(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_542)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_60_542)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_60_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92469 18.5697C10.7647 14.3697 14.5447 11.2197 18.9547 11.2197C22.1047 11.2197 24.6247 12.6897 26.3047 14.9997L29.8747 10.7997C27.3547 7.85973 23.3647 5.96973 18.9547 5.96973C11.6047 5.96973 5.51469 11.4297 4.46469 18.5697H0.0546875L7.40469 26.9697L14.7547 18.5697H9.92469ZM30.5047 14.3697L23.1547 22.7697H27.9847C26.9347 26.9697 23.3647 30.1197 18.9547 30.1197C15.8047 30.1197 13.2847 28.6497 11.6047 26.3397L8.03469 30.3297C10.5547 33.4797 14.5447 35.3697 18.9547 35.3697C26.3047 35.3697 32.3947 29.9097 33.4447 22.7697H37.8547L30.5047 14.3697Z",
    fill: "url(#paint0_linear_60_542)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_542",
    x1: 4.81873,
    y1: -12.1513,
    x2: 47.4046,
    y2: -0.955444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.394531 0.669922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_60_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.394531 0.669922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_60_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.394531 0.669922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuous);
export default __webpack_public_path__ + "static/media/continuous.f7661f50ff89bee608404fc21863036d.svg";
export { ForwardRef as ReactComponent };